import React, { useState, useEffect } from 'react'
import { components, useServices, useTranslation } from 'cng-web-lib'
import Namespace from '../../../constants/locale/Namespace'
import AceHighwayAbiInbondEventKeys from 'src/constants/locale/key/AceHighwayAbiInbondEvent'
import AceHwyInbondArrivalApiUrls from 'src/apiUrls/AceHwyInbondArrivalApiUrls'
import { Box, Grid, Paper } from '@material-ui/core'
import { FileForUserGetUserDetails } from 'src/common/FileForUserCommon'
import ErrorMessageSection from 'src/views/common/ErrorMessageSection'
import ACEHighwayInbondEventTranslationText from '../contexts/ACEHighwayInbondEventTranslationText'
import ACEHighwayShipmentTranslationText from '../contexts/ACEHighwayShipmentTranslationText'
import NaCommonTranslationText from 'src/common/NaCommonTranslationText'
import ACEHighwayManifestTranslationText from '../contexts/ACEHighwayManifestTranslationText'

const {
  button: { CngButton },
  dropzone: { CngFileUpload },
  CngDialog
} = components

function InbondEventUploadDialog(props) {
  const { manifestId, onClose, open, showNotification } = props

  const [files, setFiles] = useState([])
  const [errorMessages, setErrorMessages] = useState([])
  const [loading, setLoading] = useState(false)
  const { securedSendRequest } = useServices()
  const { translate } = useTranslation(Namespace.ACE_HIGHWAY_ABI_INBOND_EVENT)
  const translatedTextsObject = ACEHighwayInbondEventTranslationText()
  const shipmentTranslatedTextsObject = ACEHighwayShipmentTranslationText()
  const manifestTranslatedTextsObject = ACEHighwayManifestTranslationText()
  const commonTranslatedTextsObject = NaCommonTranslationText()

  useEffect(() => {
    setFiles([])
    setErrorMessages([])
  }, [open]);

  const downloadFile = () => {
    const blob = new Blob(["S No,Acct ID,User ID,Entry Filer Code,In-bond Number,Master BOL With Issuer Code,FIRMS Location on In-Bond Arrival,Container Number,Date and Time,Action Code,Port of Arrival,In-bond Carrier Code,Bonded Carrier ID,City,State Code,Export Mode Of Transport,Export Conveyance,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,, \nHeader,AN-AlphaNumeric Characters,AN-AlphaNumeric Characters,M-Mandatory,N-NumeriC\,C-Conditional,M-Mandatory O-Optional,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,\n,\"O\,6AN\",\"O\,10AN\",\"M\,3AN\",\"M\,12AN\",\"C\,16AN\",\"C\,4AN\",\"C\,14AN\",\"M\,12X\",\"M\,1AN\",\"M\,4N\",\"C\,4X\",\"C\,12X\",\"C\,19AN\",\"C\,2A\",\"O\,2N\",\"O\,23AN\",,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,\n1,iilt,iilt001,MEO,99999295,ABCD23312312,0101,1234,2024050616:16:16,1,3801,TEST,999999999,TORONTO,CA,10,Akme,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,"], { type: "text/csv" })
    const element = document.createElement("a");
    element.href = window.URL.createObjectURL(blob)
    element.download = "ACEHWY_InbondEvent_SampleUpload.csv";
    document.body.appendChild(element);
    element.click();
    element.parentNode.removeChild(element);
  }

  function handleUploadInbondEvent() {
    try {
      setLoading(true)

      let fileForUserDetails = FileForUserGetUserDetails();
      const formData = new FormData()

      formData.append('file', files[0].file)
      if (fileForUserDetails != null && fileForUserDetails != undefined) {
        formData.append("fileForUserDetails", JSON.stringify(fileForUserDetails))
      } else {
        formData.append("fileForUserDetails", "{}")
      }

      securedSendRequest.execute(
        'POST',
        AceHwyInbondArrivalApiUrls.UPLOAD,
        formData,
        (response) => {
          if (response.status === 200) {
            if (response.data) {
              const errorMessages = response.data.errorMessages

              if (errorMessages) {
                setErrorMessages(errorMessages)
                setFiles([])
              }
            } else {
              showNotification('success', shipmentTranslatedTextsObject.uploadSuccessMsg)
              onClose()
              open.tableRef.current.performRefresh()
            }
          }
        },
        () => {
          showNotification('error', translatedTextsObject.uploadInbondErrorMsg)
          setFiles([])
        },
        () => setLoading(false)
      )
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <CngDialog
      dialogTitle={translatedTextsObject.uploadNewInbond}
      dialogContent={
        <Paper variant='outlined'>
          <Box padding={2}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <CngFileUpload
                  accept={['.csv']}
                  files={files}
                  maxFiles={1}
                  maxSize={5.3e+7}
                  onFileSelect={(file) => setFiles(file)}
                  showFormFields={false}
                  moreActions={[
                    {
                      action: 'remove',
                      name: commonTranslatedTextsObject.removeButton,
                      icon: ['fal', 'trash']
                    }
                  ]}
                  onDropRejected={(errorMessages) => console.log(errorMessages)}
                />
              </Grid>

              <ErrorMessageSection errorMessages={errorMessages} />

              <Grid item xs={12}>
                <Grid container justify='flex-end' spacing={2}>
                  <Grid item xs='auto'>
                    <CngButton size='medium' variant='outlined' onClick={downloadFile}>
                      {shipmentTranslatedTextsObject.downloadTemplateCsv}
                    </CngButton>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      }
      dialogAction={
        <>
          <CngButton color='secondary' disabled={loading} onClick={onClose}>
            {manifestTranslatedTextsObject.discardButton}
          </CngButton>
          <CngButton
            color='primary'
            disabled={loading}
            onClick={handleUploadInbondEvent}
            shouldShowProgress={loading}
          >
            {translatedTextsObject.saveButton}
          </CngButton>
        </>
      }
      fullWidth
      maxWidth='lg'
      open={open.open}
      onClose={onClose}
      shouldShowCloseButton
    />
  )
}

export default InbondEventUploadDialog
